import { TabsProps } from 'antd';
import { SegmentedOptions } from 'antd/es/segmented';
import { lazyImport } from 'routes/helpers';

/** Khách sạn */

export const HotelDetail = lazyImport(
  () => import('features/hotel/components/HotelDetail')
);

export const HotelDetailGalleryConfig = lazyImport(
  () => import('features/hotel/components/HotelDetailGalleryConfig')
);

export const HotelDetailRoomConfig = lazyImport(
  () => import('features/hotel/components/HotelDetail/HotelDetailRoomConfig')
);

export enum HOTEL_DETAIL_TABS {
  HOTEL_DETAILS = 'info',
  ROOM_DETAILS = 'room',
  GALLERY = 'gallery',
}

export const hotelTabLabels: Record<HOTEL_DETAIL_TABS, string> = {
  [HOTEL_DETAIL_TABS.HOTEL_DETAILS]: 'Cài đặt thông tin khách sạn',
  [HOTEL_DETAIL_TABS.GALLERY]: 'Cài đặt thư viện ảnh khách sạn',
  [HOTEL_DETAIL_TABS.ROOM_DETAILS]: 'Danh sách phòng',
};

export const hotelTabItems: SegmentedOptions<HOTEL_DETAIL_TABS> = [
  {
    value: HOTEL_DETAIL_TABS.HOTEL_DETAILS,
    label: hotelTabLabels[HOTEL_DETAIL_TABS.HOTEL_DETAILS],
  },
  {
    value: HOTEL_DETAIL_TABS.GALLERY,
    label: hotelTabLabels[HOTEL_DETAIL_TABS.GALLERY],
  },
  {
    value: HOTEL_DETAIL_TABS.ROOM_DETAILS,
    label: hotelTabLabels[HOTEL_DETAIL_TABS.ROOM_DETAILS],
  },
];

/** Phòng khách sạn */

export enum HOTEL_ROOM_DETAIL_TABS {
  DETAILS = 'info',
  GALLERY = 'gallery',
  REPORT = 'report',
}

export const hotelRoomTabLabels: Record<HOTEL_ROOM_DETAIL_TABS, string> = {
  [HOTEL_ROOM_DETAIL_TABS.DETAILS]: 'Thông tin phòng',
  [HOTEL_ROOM_DETAIL_TABS.GALLERY]: 'Thư viện ảnh',
  [HOTEL_ROOM_DETAIL_TABS.REPORT]: 'Báo cáo đặt phòng',
};

export const hotelRoomDetailTabItems: SegmentedOptions<HOTEL_ROOM_DETAIL_TABS> =
  [
    {
      value: HOTEL_ROOM_DETAIL_TABS.DETAILS,
      label: hotelRoomTabLabels[HOTEL_ROOM_DETAIL_TABS.DETAILS],
    },
    {
      value: HOTEL_ROOM_DETAIL_TABS.GALLERY,
      label: hotelRoomTabLabels[HOTEL_ROOM_DETAIL_TABS.GALLERY],
    },
    {
      value: HOTEL_ROOM_DETAIL_TABS.REPORT,
      label: hotelRoomTabLabels[HOTEL_ROOM_DETAIL_TABS.REPORT],
    },
  ];
